import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

interface TabProps {
  active: boolean;
}

const TabContainer = styled.div`
  display: flex;
  background: transparent;
  user-select: none;
  position: relative;
  top: -28px;
  left: -1px;
  overflow-x: auto;
  overflow-y: hidden;
  @media screen and ${(props) => props.theme.breakpoints.lg} {
    font-size: 14px;
    top: -42px;
  }
`;
const Tab = styled.span<TabProps>`
  position: relative;
  bottom: -2px;
  cursor: pointer;
  padding: 4px 6px;
  color: ${(props) => (props.active ? '#d73714' : '#5c5f63')};
  font-family: acumin-pro;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 17px;
  background: ${(props) => (props.active ? '#fff' : '#e7eaef')};
  border: 1px solid #d6dce2;
  border-radius: 3px 3px 0 0;
  border-bottom: none;
  white-space: nowrap;
  margin-right: 8px;
  @media screen and ${(props) => props.theme.breakpoints.lg} {
    font-size: 14px;
    padding: 12px 16px;
    margin-right: 16px;
  }
`;
const TabIcon = styled(FontAwesomeIcon)<TabProps>`
  color: ${(props) => (props.active ? '#d73714' : '#a8aeb4')};
  margin-right: 10px;
`;

const FormTabs = ({
  currentTab,
  onTabChange,
}: {
  currentTab: number;
  onTabChange: Function;
}) => {
  const { t } = useTranslation();
  return (
    <TabContainer>
      <Tab active={currentTab === 0} onClick={() => onTabChange(0)}>
        <TabIcon
          icon={['far', 'user-circle']}
          fontSize="1.1em"
          active={currentTab === 0}
        />
        {t('application-profile')}
      </Tab>
      <Tab active={currentTab === 1} onClick={() => onTabChange(1)}>
        <TabIcon
          icon={['far', 'briefcase']}
          fontSize="1.1em"
          active={currentTab === 1}
        />
        {t('sent-applications')}
      </Tab>
      <Tab active={currentTab === 2} onClick={() => onTabChange(2)}>
        <TabIcon
          icon={['far', 'comment']}
          fontSize="1.1em"
          active={currentTab === 2}
        />
        {t('conversation-requests')}
      </Tab>
      <Tab active={currentTab === 3} onClick={() => onTabChange(3)}>
        <TabIcon
          icon={['far', 'envelope']}
          fontSize="1.1em"
          active={currentTab === 3}
        />
        {t('messages')}
      </Tab>
    </TabContainer>
  );
};

export default FormTabs;
